var _defs, _path, _polygon, _path2, _path3, _line, _line2, _path4, _path5, _path6, _path7, _path8, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildcaredisqualification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.73,238A15.27,15.27,0,0,1,45.5,222.77V67.9L102,18h93.26A15.27,15.27,0,0,1,210.5,33.23V222.77A15.23,15.23,0,0,1,195.27,238Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.52,152.44a3.77,3.77,0,0,1-3.6,3.09H100.47a3.77,3.77,0,0,1-3.6-3.09l-2.11-13.76a2.61,2.61,0,0,1,2.65-3.09H167a2.61,2.61,0,0,1,2.65,3.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.73,93.45c-4.66.93-13.2,8.84-26.4,2.18l8.76,39.88"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.92,
    y1: 135.51,
    x2: 146.73,
    y2: 93.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 130.92,
    y1: 135.51,
    x2: 167.07,
    y2: 110.26
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.07,110.26c-3.95-2.29-16.8-3.87-20.32-16.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.41,137a32.13,32.13,0,0,1-2-26.39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.67,138.08s-2-18.59-19.2-18.59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.87,185.78a6.8,6.8,0,1,1-6.8-6.79A6.8,6.8,0,0,1,163.87,185.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.83,185.78A6.8,6.8,0,1,1,106,179,6.79,6.79,0,0,1,112.83,185.78Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.41,
    y1: 155.58,
    x2: 110.1,
    y2: 180.34
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.69,
    y1: 155.58,
    x2: 153.01,
    y2: 180.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildcaredisqualification);
export default __webpack_public_path__ + "static/media/childcaredisqualification.b554b24d5f672bd307731ee48469cc7a.svg";
export { ForwardRef as ReactComponent };